import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: 'AIzaSyB-Rcs_tcQ1HjaPxcjNok44tGDHO4Fylyw',
  authDomain: 'portfolio-morena.firebaseapp.com',
  projectId: 'portfolio-morena',
  storageBucket: 'portfolio-morena.firebasestorage.app',
  messagingSenderId: '6563111302',
  appId: '1:6563111302:web:008b0207f71e49a1d84c07',
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
